/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Edit_TitleInputs */

const en_views_edit_title = /** @type {(inputs: Views_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename and share`)
};

const de_views_edit_title = /** @type {(inputs: Views_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umbenennen und teilen`)
};

/**
* | output |
* | --- |
* | "Rename and share" |
*
* @param {Views_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_edit_title = /** @type {((inputs?: Views_Edit_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Edit_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_edit_title(inputs)
	return en_views_edit_title(inputs)
});